<template>
  <div class="digitalVillage">
    <div class="modular">
      <div class="title">
        <!-- <div class="text">
          智慧数字乡村建设，利用现代信息与互联网技术，构建<span>以网络通信为基础,村大数据为支撑</span>的数据处理中心；构筑<span>智慧管理、智慧服务、智慧决策</span>三大应用体系，共建共享、互融互通的数字乡村框架体系，切实提升村级信息化水平。为乡村实现精细化管理、个性化服务奠定坚实基础，完成<span>信息化体系</span>初步建设，预留拓展空间。通过数字化建设<span>提高农村地区治安管理水平</span>，推广使用各类个体感知、环境监测农业物联网设备。建设<span>智能农业生产决策控制</span>体系，结合乡村旅游发展大趋势，发挥数字乡村的引领作用，整合周边资源，实现乡村可持续发展。
        </div> -->
        <div class="name">数字乡村</div>
        <div class="text">提升乡村旅游建设，带动农村产业发展</div>
      </div>
      <ul class="ul">
        <li class="li" v-for="(item, index) in list" :key="index">
          <div class="icon">
            <img :src="item.imgUrl" alt="" />
          </div>
          <div class="text">
            <div class="top">{{ item.title }}</div>
            <div class="bottom">{{ item.text }}</div>
          </div>
        </li>
      </ul>
      <!-- <div class="img">
        <img src="../img/village.png" alt="" />
      </div> -->
    </div>
  </div>
</template>

<script>
export default {
  name: 'digitalVillage',
  data() {
    return {
      list: [
        { imgUrl: require('../img/masonry.png'), title: '智慧治理', text: '优化乡村治理方式，充分释放“互联网+三治结合”新效能，接入“基层治理四平台”，实现事件处理全流程跟踪反馈。' },
        { imgUrl: require('../img/masonry.png'), title: '智慧旅游', text: '运用互联网思维，整合乡村旅游资源，不断进行旅游产品的开发和创新，以满足游客个性化、多元化的需求。' },
        { imgUrl: require('../img/masonry.png'), title: '平安乡村', text: '通过建设安防、消防、灾害监测、人脸比对、车牌识别等系统，创建平安乡村。实现人流过密、车流过载预警，可疑车辆、人员布控，提升突发事件应急处置能力。' },
        { imgUrl: require('../img/masonry.png'), title: '智慧农业', text: ' 集成大数据、物联网技术、音视频技术、卫星遥感技术、移动互联网等信息技术，实现农业可视化远程诊断、远程控制、灾变预警等智能管理。' }
      ]
    };
  },
  computed: {},
  watch: {},
  methods: {},
  mounted() {}
};
</script>

<style scoped lang="scss">
@import url('~@/icons/pingfang/font.css');
.digitalVillage {
  position: relative;
  background: #efeff4;
  .modular {
    margin: 0 auto;
    width: 100%;
    height: 1255px;
    background: #efeff4;
    overflow: hidden;
    .title {
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-top: 110px;
      padding: 0 354px 0 423px;
      .name {
        font-weight: 600;
        font-size: 40px;
      }
      .text {
        margin-top: 30px;
        font-size: 28px;
        font-family: 'PingFang';
        font-weight: 600;
        color: #252525;
      }
    }
    .ul {
      display: flex;
      flex-flow: wrap;
      height: 630px;
      padding: 77px 180px 0 340px;
      .li {
        display: flex;
        height: 250px;
        .icon {
          margin-top: 10px;
          margin-right: 30px;
        }
        .text {
          .top {
            font-size: 30px;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 550;
            color: #252525;
          }
          .bottom {
            margin-top: 20px;
            font-size: 22px;
            letter-spacing: 2px;
            line-height: 37px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #252525;
          }
        }
      }
    }
    .img {
      position: absolute;
      top: 630px;
      left: 780px;
      width: 345px;
      height: 345px;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
}
</style>
